<script>
import DatePicker from 'vue-datepicker-next';
import { useI18n } from 'vue-i18n';
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change'],

  setup() {
    const { locale } = useI18n({ useScope: 'global' });

    return {
      locale,
    };
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      range
      confirm
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :lang="locale"
      @change="handleChange"
    />
  </div>
</template>
